import {InputProps} from "antd/lib/input";
import {Input} from "antd";

export interface IcanIdInputProps extends InputProps {}

export default function IcanIdInput(props: IcanIdInputProps) {
    // TODO: Implement validation of ICAN ID
    return <Input {...props} />;
}